import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Footer = () => {
  return (
    <Wrap>
      <FooterRow>
        <FooterColumn>
          <h3>About Us</h3>
          <ul>
            <li>
              <Link to="/Company" title="">
                Company
              </Link>
            </li>
            <li>
              <Link to="/HelpCentre" title="">
                Help Centres
              </Link>
            </li>
            <li>
              <Link to="/Careers" title="">
                Careers
              </Link>
            </li>
          </ul>
        </FooterColumn>

        <FooterColumn>
          <h3>Services</h3>
          <ul>
            <li>
              <Link to="/Portfolio" title="">
                Portfolio
              </Link>
            </li>
            <li>
              <Link to="/CryptocurrenciesList" title="">
                Markets
              </Link>
            </li>
            <li>
              <Link to="/News" title="">
                News
              </Link>
            </li>
            <li>
              <Link to="/Merch">Merch</Link>
            </li>
          </ul>
        </FooterColumn>

        <FooterColumn>
          <h3>Legal</h3>
          <ul>
            <li>
              <Link to="/TermsOfUse" title="">
                Terms of use
              </Link>
            </li>
            <li>
              <Link to="/">Client Protection</Link>
            </li>
            <li>
              <Link to="/">Legal Compliance</Link>
            </li>
            <li>
              <Link to="/">Privacy Policy</Link>
            </li>
          </ul>
        </FooterColumn>

        <FooterColumn>
          <h3>Social Media</h3>

          <SocialMedia>
            <a
              href="https://www.facebook.com/lehumo.global"
              target="_blank"
              rel="noopener noreferrer"
              title=""
            >
              <i className="fab fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/lehumo.global"
              target="_blank"
              rel="noopener noreferrer"
              title=""
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.twitter.com/lehumoglobal"
              target="_blank"
              rel="noopener noreferrer"
              title=""
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.tiktok.com/@lehumo.global"
              target="_blank"
              rel="noopener noreferrer"
              title=""
            >
              <i className="fab fa-tiktok"></i>
            </a>
            <a
              href="https://www.youtube.com/@lehumo.global"
              target="_blank"
              rel="noopener noreferrer"
              title=""
            >
              <i className="fab fa-youtube"></i>
            </a>
          </SocialMedia>
        </FooterColumn>
      </FooterRow>
    </Wrap>
  );
};

export default Footer;

const Wrap = styled.div`
  width: 100%;
  position: absolute;
  background-color: var(--background);
  color: #333;
  padding: 50px 0 30px;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  overflow: hidden;
  left: 0;
  right: 0;

  hr {
    width: 90%;
    border: 0;
    border-bottom: 1px solid #ccc;
    margin: 20px auto;
  }

  p {
    font-size: 12px;
  }

  span {
    font-weight: bold;
    text-transform: lowercase;
  }
`;

const FooterRow = styled.div`
  width: 85%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
`;

const FooterColumn = styled.div`
  flex-basis: 25%;
  padding: 10px;
  text-align: left;

  @media (max-width: 768px) {
    flex-basis: 100%;
  }

  :nth-child(2),
  :nth-child(3) {
    flex-basis: 15%;

    @media (max-width: 768px) {
      flex-basis: 100%;
    }
  }

  ul {
    list-style: none;
    font-size: 12px;
  }

  a {
    color: #333;

    :hover {
      color: var(--primary);
      transition: all ease 0.3s;
    }
  }

  h3 {
    margin-bottom: 10px;
    font-size: 14px;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  p {
    font-size: 12px;
  }

    far {
      font-size: 18px;
      margin-right: 10px;
    }

    button {
      background: transparent;
      border: 0;
      outline: none;
      cursor: pointer;
      font-size: 16px;
      color: #ccc;

      :hover {
        color: #b0a9aa;
      }
    }
  }
`;

const SocialMedia = styled.div`
  .fab {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
    color: #fff;
    background: #333;
    margin-right: 5px;
    cursor: pointer;

    @media (max-width: 912px) {
      width: 35px;
      height: 35px;
      line-height: 35px;
      margin-right: 6px;
    }
  }

  .fab:hover {
    color: #fff;
    background: var(--primary);
    transition: all ease 0.5s;
  }
`;
